<template>
  <div class="app-inner">
    <el-form
    ref="form"
    :model="infoData"
    label-width="120px"
    :rules="rules"
    >
      <el-form-item label="上班时间" prop="workTime">
        <el-time-picker
        v-model="infoData.workTime"
        placeholder="请选择上班时间"
        format='HH:mm'
        value-format="HH:mm"/>
      </el-form-item>
      <el-form-item label="上班地点" prop="workPlace">
        <position-select style="width: 220px"
        v-model="infoData.workPlace"
        :lon="infoData.worklon"
        :lat="infoData.worklat"
        @change="positionchange"
        type='work'
        />
      </el-form-item>
      <el-form-item label="上班打卡范围" prop="workDistance">
        <el-input style="width: 220px" placeholder="请输入上班打卡范围" v-model="infoData.workDistance"/>
        <span style="margin-left: 10px">KM</span>
      </el-form-item>
      <el-form-item label="下班时间" prop="closingTime">
        <el-time-picker
        v-model="infoData.closingTime"
        placeholder="请选择下班时间"
        format='HH:mm'
        value-format="HH:mm"/>
      </el-form-item>
      <el-form-item label="下班地点" prop="closingPlace">
        <position-select
        style="width: 220px"
        v-model="infoData.closingPlace"
        :lon="infoData.closinglon"
        :lat="infoData.closinglat"
        @change="positionchange"
        type='closing'/>
      </el-form-item>
      <el-form-item label="下班打卡范围" prop="closingDistance">
        <el-input style="width: 220px" placeholder="请输入下班打卡范围" v-model="infoData.closingDistance"/>
        <span style="margin-left: 10px">KM</span>
      </el-form-item>
    </el-form>
    <div style="text-align: center;">
      <el-button  type="primary" @click="save">保 存</el-button>
    </div>
  </div>
</template>

<script>
import PositionSelect from './positionSelect.vue'
import { getThisCompanyConfig, saveOrUpdate } from '@/api/calendarController'
export default {
  data () {
    return {
      id: '',
      infoData: {
        workTime: '', // 上班时间
        workDistance: '', // 上班打卡距离
        workPlace: '', // 上班地点
        worklon: '', // 上班地点经度
        worklat: '', // 上班地点纬度
        closingTime: '', // 下班时间
        closingDistance: '', // 下班打卡距离
        closingPlace: '', // 下班打卡地点
        closinglon: '', // 下班地点经度
        closinglat: '' // 下班地点纬度
      },
      rules: {
        workTime: [
          { required: true, message: '请选择上班时间', trigger: 'change' }
        ],
        workPlace: [
          { required: true, message: '请输入上班地点', trigger: 'change' }
        ],
        workDistance: [
          { required: true, message: '请输入上班打卡范围', trigger: 'change' }
        ],
        closingTime: [
          { required: true, message: '请选择下班时间', trigger: 'change' }
        ],
        closingPlace: [
          { required: true, message: '请输入下班地点', trigger: 'change' }
        ],
        closingDistance: [
          { required: true, message: '请输入下班打卡范围', trigger: 'change' }
        ]
      }
    }
  },
  components: {
    PositionSelect
  },
  methods: {
    positionchange (value = {}, type) {
      console.log(value, '111')
      const { name = '', location = '' } = value
      this.infoData = {
        ...this.infoData,
        [`${type}Place`]: name || '',
        [`${type}lon`]: location.split(',')?.[0] || '',
        [`${type}lat`]: location.split(',')?.[1] || ''
      }
    },
    save () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          saveOrUpdate({
            id: this.id,
            config: JSON.stringify(this.infoData),
            name: '考勤管理'
          }).then(res => {
            const { code } = res
            if (code === 0) this.$message.success('修改成功')
            this.getConfig()
          })
        }
      })
    },
    getConfig () {
      getThisCompanyConfig().then(res => {
        console.log(res)
        const { code, result } = res
        this.id = result.id
        if (code !== 0) return
        let config = JSON.parse(result.config) || '{}'
        this.infoData = {
          ...config
        }
         this.$refs.form.resetFields()
      })
    }
  },
  mounted () {
    this.getConfig()
  }
}
</script>
